export default {"src":"/_next/static/media/close.97943f5d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};